// src/configColor.ts

// Define and export a color palette
export const colorPalette: string[] = [
  '#FEB019', // Orange
  '#008FFB', // Blue
  '#00E396', // Green
  '#FF4560', // Red
  '#775DD0', // Purple
  '#546E7A', // Dark Gray
  '#26A69A', // Teal
  '#D32F2F', // Dark Red
  '#7E57C2', // Indigo
  '#8D6E63', // Brown
  '#FFB74D', // Light Orange
  '#64B5F6', // Light Blue
  '#81C784', // Light Green
  '#BA68C8', // Light Purple
  '#4DB6AC', // Light Teal
  '#E57373', // Pink
  '#9575CD', // Medium Purple
  '#4FC3F7', // Sky Blue
  '#A1887F', // Taupe
  '#90A4AE', // Cool Gray
];
